import { Component, EventEmitter, Inject, OnInit, Output, Renderer2 } from '@angular/core';
import { ProductService } from 'src/_lib/service/product.service';
import { environment } from 'src/environments/environment.prod';
import { CommonModule, DOCUMENT } from '@angular/common';
import { gallery_photos } from 'src/_lib/interfaces/gallery-photos.interface';
import { BrowserService } from 'src/_lib/service/browser.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-gallary-photos',
  templateUrl: './gallary-photos.component.html',
  styleUrls: ['./gallary-photos.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class GallaryPhotosComponent implements OnInit {
  galleryPhotos: gallery_photos[] = [];
  imageObject: string;
  productKey: number;
  cdnImagePath: string = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  showSlider = false;
  currentIndex: number;

  @Output() galleryStatus = new EventEmitter<boolean>();

  constructor(
    private browser: BrowserService,
    private prodservice: ProductService,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    if (this.browser.isServer) {
      const id: string = this.route.snapshot.params['id'] || '';
      if (id.startsWith('p') && id.length > 1) {
        this.productKey = +id.slice(1);
      }
    }
    this.productKey = +(
      this.browser.localStorage?.getItem('selectedproductkey') || 0
    );

    if (this.productKey) {
      this.fetchGalleryPhotos(this.productKey);
    }
  }

  fetchGalleryPhotos(productKey: number): void {
    this.prodservice.galaryphotos(productKey).subscribe((response: any) => {
      if (response?.[0]?.success === true && response[0]?.data?.length > 0) {
        this.galleryPhotos = response[0].data[0].gallery_photos;
        this.galleryStatus.emit(this.galleryPhotos?.length > 0);
      } else {
        this.galleryPhotos = [];
        this.galleryStatus.emit(false);
      }
    });
  }

  closeSlider(): void {
    this.browser.runInBrowser(() => {
      this.showSlider = false;
      this.renderer.removeStyle(this.document.documentElement, 'overflow');
    });
  }

  viewSlider(i: number): void {
    this.browser.runInBrowser(() => {
      this.showSlider = true;
      this.imageObject = this.galleryPhotos[i].large_image;
      this.currentIndex = i;
      this.renderer.setStyle(this.document.documentElement, 'overflow', 'hidden');
    });
  }

  nextSlide() {
    if (this.currentIndex < this.galleryPhotos?.length - 1) {
      this.currentIndex++;
      this.imageObject =
        this.galleryPhotos[this.currentIndex].large_image ||
        `${this.commonImagePath}image_not_found.webp`;
    }
  }
  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.imageObject =
        this.galleryPhotos[this.currentIndex].large_image ||
        `${this.commonImagePath}image_not_found.webp`;
    }
  }

   onImageError(event: any): void {
    event.target.src = `${this.commonImagePath}image_not_found.webp`;
  }
}